"use client";

import Subheading from "@/app/components/ui/subheading";
import { getFunnelStepConfig } from "../constants/funnel-data";
import { useFinancialServiceFunnelStore } from "@/app/stores/financial-service-funnel-store";

export default function FunnelSubheading() {
  const { currentStep } = useFinancialServiceFunnelStore();
  const { subheading } = getFunnelStepConfig(currentStep);

  return <Subheading>{subheading}</Subheading>;
}
